import type { ColumnsType } from "antd/es/table";
import {
  Pagination,
  Space,
  Table,
  Popconfirm,
  notification,
  Input,
} from "antd";
import { BiEdit } from "react-icons/bi";
import moment from "moment";
import axios from "axios";
import { API } from "../../../config/API";
import { IoTrashOutline } from "react-icons/io5";

function TagDataTable(props: any) {
  interface DataType {
    key: string;
    id: number;
    news: string;
    newshead: string;
    address: string;
    imageurl: string[];
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => {
        return <div className="">{index + 1}</div>;
      },
    },
    {
      title: "Tag",
      dataIndex: "attributes",
      key: "tag",
      width: 500,
      render: (text, record: any) => {
        return <div style={{ fontSize: "10px" }}>{record.tag}</div>;
      },
    },
    {
      title: "CreatedAt",
      dataIndex: "attributes",
      key: "createdAt",
      width: 500,
      render: (text, record: any) => {
        const createdAt = moment(record.createdAt).format("LL");
        return <div style={{ fontSize: "10px" }}>{createdAt}</div>;
      },
    },
    {
      title: "publishedAt",
      dataIndex: "attributes",
      key: "publishedAt",
      width: 500,
      render: (text, record: any) => {
        const PublishedAt = moment(record.publishedAt).format("LL");
        return <div style={{ fontSize: "10px" }}>{PublishedAt}</div>;
      },
    },
    {
      title: "Task",
      key: "action",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
            }}
          >
            <Space size="middle" style={{ marginRight: 10 }}>
              <BiEdit
                size={20}
                color="#f5a442"
                cursor={"pointer"}
                onClick={() => props.onEdit(record)}
              />
            </Space>
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => deleteData(record.id)}
            >
              <Space size="middle">
                <IoTrashOutline size={20} color="red" cursor={"pointer"} />
              </Space>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const deleteData = (id: any) => {
    let url = API.BASE_URL + API.TAGS + `/${id}`;
    axios
      .delete(url)
      .then((response) => {
        notification.success({ message: "Tag deleted successfully" });
        props.refresh();
      })
      .catch((error) => {
        console.log("======delte--error====", error);
      });
  };
  const handleSearch = (val: any) => {
    props.Search(val);
  };

  return (
    <div className="mt-2" style={{ height: "90vh", overflowY: "scroll" }}>
      {/* <Space.Compact
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <Input.Search
          enterButton
          loading={props.searching}
          allowClear
          placeholder="Search Tag"
          style={{ width: "30%" }}
          onChange={(e) => {
            if (e.target.value === "") {
              props.onClear();
            }
          }}
          onSearch={(e) => {
            if (e === "") {
              props.onClear();
            } else {
              console.log(e);
              handleSearch(e);
            }
          }}
        />
      </Space.Compact> */}
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={false}
        size="small"
      />
      <br />
      <div style={{ textAlign: "end", marginBottom: "100px" }}>
        <Pagination
          responsive
          defaultCurrent={props?.page}
          total={props?.meta}
          pageSize={props?.pagesize}
          onChange={(p, t) => {
            props.onPageChange(p, t);
          }}
        />
        <br />
      </div>
    </div>
  );
}

export default TagDataTable;
